import { useContext } from 'react';

import CellSelectionContext from './Context';
import CellSelectionProvider from './Provider';

const useCellSelectionContext = () => useContext(CellSelectionContext);

export { CellSelectionContext, CellSelectionProvider, useCellSelectionContext };
